// Header.js
import React, { useState } from "react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="home-header">
      <div className="logo-container">
        <a href="https://ronniceramics.com/">
          <img
            src={"../ronniceramics.logo.png"}
            alt="Ronni Ceramics Logo"
            className="ronni-logo"
          />
        </a>
      </div>
      <nav className={`home-nav ${isMenuOpen ? "open" : ""}`}>
        <a
          href="https://ronniceramics.com/"
          className="nav-link"
          onClick={toggleMenu}
        >
          Shtëpia
        </a>
        <a
          href="https://ronniceramics.com/about-us"
          className="nav-link"
          onClick={toggleMenu}
        >
          Rreth Nesh
        </a>
        <a
          href="https://ronniceramics.com/shop"
          className="nav-link"
          onClick={toggleMenu}
        >
          Dyqani
        </a>
        <a
          href="https://ronniceramics.com/contact-us"
          className="nav-link"
          onClick={toggleMenu}
        >
          Na Kontaktoni
        </a>
      </nav>
      <button
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
    </header>
  );
};

export default Header;
